<template>
    <div></div>
</template>

<script>
    export default {
        name: "Organisation"
    }
</script>

<style scoped>

</style>